import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryResultsModel } from '../../_base/crud';
// State
import { CategoryDescriptionState } from '../_reducers/category-description.reducers';
import { CategoryDescription } from '../_models/category-description.model';

export const selectCategoryDescriptionState =
  createFeatureSelector<CategoryDescriptionState>('CategoryDescription');

export const selectCategoryDescriptionById = (categoryDescriptionId: number) =>
  createSelector(
    selectCategoryDescriptionState,
    (categoryDescriptionState) => categoryDescriptionState.entities[categoryDescriptionId],
  );

export const selectCategoryDescriptionPageLoading = createSelector(
  selectCategoryDescriptionState,
  (categoryDescriptionState) => {
    return categoryDescriptionState.listLoading;
  },
);

export const selectCategoryDescriptionActionLoading = createSelector(
  selectCategoryDescriptionState,
  (categoryDescriptionState) => categoryDescriptionState.actionsloading,
);

export const selectLastCreatedCategoryDescriptionId = createSelector(
  selectCategoryDescriptionState,
  (categoryDescriptionState) => categoryDescriptionState.lastCreatedCategoryDescriptionId,
);

export const selectLastCreatedCategoryDescription = createSelector(
  selectCategoryDescriptionState,
  (categoryDescriptionState) => categoryDescriptionState.lastCreatedCategoryDescription,
);

export const selectCategoryDescriptionPageLastQuery = createSelector(
  selectCategoryDescriptionState,
  (categoryDescriptionState) => categoryDescriptionState.lastQuery,
);
export const selectCategoryDescriptionError = createSelector(
  selectCategoryDescriptionState,
  (categoryDescriptionState) => categoryDescriptionState.error,
);
export const selectCategoryDescriptionLatestSuccessfullAction = createSelector(
  selectCategoryDescriptionState,
  (categoryDescriptionState) => categoryDescriptionState.latestSuccessfullAction,
);
export const selectCategoryDescriptionInStore = createSelector(
  selectCategoryDescriptionState,
  (categoryDescriptionState) => {
    const items = (categoryDescriptionState.ids as number[])
      .map((id) => categoryDescriptionState.entities[id])
      .filter((item): item is CategoryDescription => item !== undefined);
    return new QueryResultsModel(items, categoryDescriptionState.totalCount);
  },
);

export const selectCategoryDescriptionShowInitWaitingMessage = createSelector(
  selectCategoryDescriptionState,
  (categoryDescriptionState) => categoryDescriptionState.showInitWaitingMessage,
);

export const selectHasCategoryDescriptionInStore = createSelector(
  selectCategoryDescriptionState,
  (queryResult) => {
    if (!queryResult.totalCount) {
      return false;
    }

    return true;
  },
);
